import { postJSON, getJSON } from "@js/helpers/communication.js";
const BEE = {
  getToken: (fn) => {
    let url = Routes.bee_callback_path();
    postJSON(url, {}, (data, err) => {
      if (data && data.success && data.token) {
        let results = {
          token: data.token,
          bee_uid: data.bee_uid,
        };
        fn(results, null);
      } else if (data && data.error) {
        fn(null, data.error);
      } else {
        fn(null, err || t("phrases.react_content.unknown_error"));
      }
    });
  },
  runSystemConfigTest: () => {
    let results = $("#system_config_bee_integration_test_results");
    let clientID = $("#system_config_bee_integration_client_id").val();
    let clientSecret = $("#system_config_bee_integration_client_secret").val();

    let writeBusy = () => {
      results.html(
        $("<span></span>")
          .addClass("")
          .text(
            t(
              "simple_form.labels.system_config.bee_integration_api_run_test.running",
            ),
          ),
      );
    };

    let writeSuccess = () => {
      results.html(
        $("<span></span>")
          .addClass("success")
          .text(
            t(
              "simple_form.labels.system_config.bee_integration_api_run_test.success",
            ),
          ),
      );
    };

    let writeError = (error) => {
      results.html(
        $("<span></span>")
          .addClass("error")
          .text(error),
      );
    };

    writeBusy();

    if (!clientID || !clientSecret) {
      writeError(
        t(
          "simple_form.labels.system_config.bee_integration_api_run_test.missing_key",
        ),
      );
      return;
    }

    let callback = (data, err) => {
      if (err) {
        writeError(err);
        return;
      }
      if (!data.success) {
        writeError(
          t(
            "simple_form.labels.system_config.bee_integration_api_run_test.invalid_credentials",
          ),
        );
        return;
      }
      writeSuccess();
    };

    let url = Routes.test_new_api_key_bee_callback_path({
      client_id: clientID,
      client_secret: clientSecret,
    });

    getJSON(url, callback);
  },
};

export default BEE;

window.BEE = BEE; // So that our outdated pages (such as system config) can still use this
